{
  "name": "peg",
  "version": "0.53.0",
  "description": "Welcome to Peg!",
  "productName": "Welcome! | Peg",
  "author": "Drey <dsolano@rushmarket.com>",
  "private": true,
  "type": "module",
  "scripts": {
    "audit": "yarn npm audit --recursive",
    "docs": "jsdoc -c jsdoc.json",
    "lint": "eslint -c ./eslint.config.js './src*/**/*.{js,cjs,mjs,vue}'",
    "format": "prettier --write \"**/*.{js,ts,vue,scss,md}\" --ignore-path .gitignore --ignore-pattern \"**/src-capacitor/**\"",
    "generate-icons:test": "./scripts/generate-app-icons.sh test",
    "generate-icons:demo": "./scripts/generate-app-icons.sh demo",
    "generate-icons:prod": "./scripts/generate-app-icons.sh prod",
    "dev": "./scripts/yarn-dev-build.sh dev web test",
    "dev:demo": "./scripts/yarn-dev-build.sh dev web demo",
    "dev:no-icons": "./scripts/yarn-dev-build.sh dev web test --no-icons",
    "dev:prod": "./scripts/yarn-dev-build.sh dev web prod",
    "dev:ios:test": "./scripts/yarn-dev-build.sh dev ios test",
    "dev:ios:demo": "./scripts/yarn-dev-build.sh dev ios demo",
    "dev:ios:prod": "./scripts/yarn-dev-build.sh dev ios prod",
    "dev:and:test": "./scripts/yarn-dev-build.sh dev android test",
    "dev:and:demo": "./scripts/yarn-dev-build.sh dev android demo",
    "dev:and:prod": "./scripts/yarn-dev-build.sh dev android prod",
    "build": "./scripts/yarn-dev-build.sh build web test",
    "build:prod": "./scripts/yarn-dev-build.sh build web prod",
    "build:no-icons": "./scripts/yarn-dev-build.sh build web test --no-icons",
    "build:ios:test": "./scripts/yarn-dev-build.sh build ios test",
    "build:ios:demo": "./scripts/yarn-dev-build.sh build ios demo",
    "build:ios:prod": "./scripts/yarn-dev-build.sh build ios prod",
    "build:ios:test:local": "./scripts/yarn-dev-build.sh build ios test --local",
    "build:ios:demo:local": "./scripts/yarn-dev-build.sh build ios demo --local",
    "build:ios:prod:local": "./scripts/yarn-dev-build.sh build ios prod --local",
    "build:and:test": "./scripts/yarn-dev-build.sh build android test",
    "build:and:demo": "./scripts/yarn-dev-build.sh build android demo",
    "build:and:prod": "./scripts/yarn-dev-build.sh build android prod",
    "build:and:test:local": "./scripts/yarn-dev-build.sh build android test --local",
    "build:and:demo:local": "./scripts/yarn-dev-build.sh build android demo --local",
    "build:and:prod:local": "./scripts/yarn-dev-build.sh build android prod --local",
    "build:cleanup": "./scripts/clean-build-config.sh",
    "upgrade": "yarn dedupe && yarn upgrade-interactive",
    "prepare": "quasar prepare",
    "nuke": "scripts/yarn-nuke.sh",
    "postinstall": "yarn prepare && ./scripts/setup-git-hooks.sh && ./scripts/setup-dev-certs.sh && ./scripts/ensure-cypress-bin.sh",
    "test": "yarn test:component && cross-env START_SERVER_AND_TEST_INSECURE=1 start-server-and-test \"yarn dev:no-icons\" \"https-get://localhost:8000\" \"yarn test:e2e\"",
    "test:e2e": "./scripts/run-cypress.sh run --e2e",
    "test:e2e:ui": "./scripts/run-cypress.sh open --e2e",
    "test:component": "./scripts/run-cypress.sh run --component",
    "test:component:ui": "./scripts/run-cypress.sh open --component",
    "push:test": "WITH_E2E=1 git push",
    "release": "./scripts/cut-release.sh"
  },
  "dependencies": {
    "@awesome.me/kit-f49d62e3af": "1.0.13",
    "@capacitor-firebase/authentication": "^8.3.0",
    "@capacitor/app": "^8.1.0",
    "@capacitor/camera": "^8.2.0",
    "@capacitor/cli": "^8.4.0",
    "@capacitor/core": "^8.4.0",
    "@capacitor/geolocation": "^8.2.0",
    "@contentful/rich-text-html-renderer": "^17.2.2",
    "@contentful/rich-text-types": "^17.2.7",
    "@ionic/pwa-elements": "^3.4.0",
    "@quasar/extras": "^2.0.0",
    "@rushrecommerce/util-validator": "^1.1.1",
    "@tanstack/vue-query": "^5.101.0",
    "@vuepic/vue-datepicker": "^12.1.0",
    "@yeger/vue-masonry-wall": "^6.1.1",
    "apexcharts": "^5.14.0",
    "braintree-web": "^3.142.0",
    "braintree-web-drop-in": "1.46.1",
    "canvas-confetti": "^1.9.4",
    "contentful": "^11.12.4",
    "countup.js": "^2.10.0",
    "dayjs": "^1.11.21",
    "dompurify": "^3.4.8",
    "driver.js": "^1.4.0",
    "firebase": "^12.14.0",
    "flagsmith": "^10.0.0",
    "jose": "^6.2.3",
    "jspdf": "^4.2.1",
    "libphonenumber-js": "^1.13.6",
    "lodash-es": "^4.18.1",
    "nanoid": "^5.1.11",
    "numeral": "^2.0.6",
    "pinia": "^3.0.4",
    "prismjs": "^1.30.0",
    "quasar": "^2.19.3",
    "rollbar": "^3.1.0",
    "swiper": "^12.2.0",
    "typesense": "^3.0.6",
    "validator": "^13.15.35",
    "vue": "3.5.35",
    "vue-router": "^5.1.0",
    "vue3-apexcharts": "^1.11.1",
    "write-excel-file": "^4.1.1"
  },
  "devDependencies": {
    "@babel/runtime": "^7.29.7",
    "@cypress/code-coverage": "^4.0.3",
    "@eslint/js": "^10.0.1",
    "@netlify/plugin-lighthouse": "^6.0.4",
    "@netlify/plugin-sitemap": "^0.8.1",
    "@quasar/app-vite": "^2.6.2",
    "@quasar/icongenie": "patch:@quasar/icongenie@npm%3A5.0.0#~/.yarn/patches/@quasar-icongenie-npm-5.0.0-c2ce1cf885.patch",
    "@quasar/quasar-app-extension-qmarkdown": "^2.0.5",
    "@quasar/quasar-app-extension-testing-e2e-cypress": "^6.3.0",
    "@quasar/quasar-ui-qmarkdown": "^2.0.5",
    "@tanstack/vue-query-devtools": "^6.1.34",
    "@vitejs/plugin-vue": "^6.0.7",
    "@vue/compiler-dom": "3.5.35",
    "@vue/eslint-config-prettier": "^10.2.0",
    "@vue/server-renderer": "3.5.35",
    "autoprefixer": "^10.5.0",
    "better-docs": "^2.7.3",
    "cross-env": "^10.1.0",
    "cypress": "^15.17.0",
    "dotenv": "^17.4.2",
    "eslint": "^10.4.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-cypress": "^6.4.1",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-vue": "^10.9.2",
    "eslint-plugin-vuejs-accessibility": "^2.5.0",
    "execa": "^9.6.1",
    "globals": "^17.6.0",
    "jsdoc": "^4.0.5",
    "netlify-cli": "^26.1.0",
    "netlify-plugin-cypress": "^2.2.1",
    "postcss": "^8.5.15",
    "prettier": "^3.8.4",
    "rollup-plugin-visualizer": "^7.0.1",
    "sass-embedded": "^1.100.0",
    "sharp": "^0.34.5",
    "start-server-and-test": "^3.0.9",
    "unplugin-auto-import": "^21.0.0",
    "unplugin-vue-components": "32.1.0",
    "vite": "^8.0.16",
    "vite-plugin-checker": "^0.14.1",
    "vue-eslint-parser": "^10.4.1"
  },
  "resolutions": {
    "@isaacs/brace-expansion": "^5.0.1",
    "@koa/cors": "^5.0.0",
    "@protobufjs/utf8": "^1.1.1",
    "@tootallnate/once": "^3.0.1",
    "@xmldom/xmldom": "^0.9.10",
    "axios": "^1.15.2",
    "basic-ftp": "^5.3.1",
    "brace-expansion@npm:^2.0.1": "2.0.3",
    "brace-expansion@npm:^2.0.2": "2.0.3",
    "brace-expansion@npm:^5.0.5": "5.0.6",
    "cookie@npm:^0.4.1": "^0.7.0",
    "cross-spawn": "^6.0.6",
    "debug@npm:4.1.1": "^4.3.1",
    "file-type@npm:^19.0.0": "^21.3.1",
    "flatted": "^3.4.0",
    "follow-redirects": "^1.16.0",
    "glob@npm:^11.0.0": "^11.1.0",
    "got": "^11.8.5",
    "http-cache-semantics": "^4.1.1",
    "immutable": "^5.1.5",
    "ip-address": "^10.1.1",
    "koa": "^2.16.4",
    "lodash": "^4.17.23",
    "lodash.get": "npm:lodash-es@^4.17.21",
    "lodash.isequal": "npm:lodash-es@^4.17.21",
    "markdown-it@npm:^12.3.2": "^14.1.1",
    "markdown-it@npm:^14.1.0": "^14.1.1",
    "minimatch@npm:^10.1.1": "^10.2.3",
    "minimatch@npm:^5.1.0": "^5.1.8",
    "minimatch@npm:^9.0.4": "^9.0.7",
    "node-forge": "^1.4.0",
    "path-to-regexp@npm:~0.1.12": "0.1.13",
    "phin": "^3.7.1",
    "picomatch@npm:^4.0.2": "4.0.4",
    "picomatch@npm:^4.0.3": "4.0.4",
    "pngquant-bin": "^6.0.1",
    "protobufjs": "^7.6.4",
    "pug": "^3.0.3",
    "qs@npm:~6.14.0": "^6.14.2",
    "qs@npm:~6.14.1": "^6.14.2",
    "rollup": "^4.59.0",
    "semver-regex": "^3.1.3",
    "serialize-javascript": "^7.0.5",
    "sharp": "^0.34.5",
    "svgo": "^3.3.3",
    "systeminformation": "^5.31.6",
    "tar": "^7.5.16",
    "tar-fs": "^2.1.2",
    "underscore": "^1.13.8",
    "vue-template-compiler": "npm:@vue/compiler-sfc@^3.5.18",
    "ws": "^8.21.0",
    "yaml": "^2.8.3",
    "qs@npm:^6.5.2": "^6.15.2",
    "qs@npm:^6.15.0": "^6.15.2",
    "tmp@npm:~0.2.4": "^0.2.6",
    "tmp@npm:^0.2.0": "^0.2.6",
    "uuid@npm:^8.3.2": "^11.1.1",
    "uuid@npm:^3.0.1": "^11.1.1",
    "@grpc/grpc-js": "~1.9.16",
    "esbuild": "^0.28.1",
    "js-yaml@npm:^4.1.0": "^4.2.0",
    "js-yaml@npm:^4.1.1": "^4.2.0",
    "form-data@npm:^4.0.5": "^4.0.6",
    "form-data@npm:~4.0.4": "^4.0.6",
    "@babel/core": "^7.29.7",
    "js-yaml@npm:4.1.0": "^4.2.0",
    "front-matter@npm:^4.0.2": "patch:front-matter@npm%3A4.0.2#~/.yarn/patches/front-matter-npm-4.0.2-e1cc0efa69.patch",
    "js-yaml@npm:^3.13.1": "^4.2.0"
  },
  "engines": {
    "node": "^24.15",
    "yarn": ">=4.14"
  },
  "packageManager": "yarn@4.14.1"
}
